export const actionTypes = {
    DETAILS_SET: "DETAILS_SET",
    DETAILS_CLEAR: "DETAILS_CLEAR",
};

export const actionCreators = {
    set: (details: any) => ({
        type: actionTypes.DETAILS_SET,
        payload: { details },
    }),
    clear: () => ({
        type: actionTypes.DETAILS_CLEAR,
    }),
};

export default {
    create: actionCreators,
    type: actionTypes,
};
